import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './Hero.css';
import heroBackground from '../assets/hero-background.jpg';
import logo from '../assets/UNIFAP-1.png';

interface HeroProps {
  onMapaClick?: () => void;
  onServicosClick?: () => void;
}

const Hero: React.FC<HeroProps> = ({ onMapaClick, onServicosClick }) => {
  const navigate = useNavigate();

  const handleValidarCredenciais = () => {
    navigate('/validar-credenciais');
  };

  return (
    <section className="hero" id="inicio">
      <div 
        className="hero-background"
        style={{
          backgroundImage: `linear-gradient(90deg, 
            #1a5f3a 0%, 
            #1a5f3a 35%, 
            rgba(26, 95, 58, 0.8) 45%,
            rgba(26, 95, 58, 0.4) 55%,
            transparent 70%, 
            transparent 100%
          ), url(${heroBackground})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
      </div>

      <div className="hero-container">
        <div className="hero-content">
          <motion.div 
            className="hero-text"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
          >
            <motion.h1 
              className="hero-title"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.4 }}
            >
              Portal de Serviços
              <span className="highlight"> UNIFAP</span>
            </motion.h1>
            
            <motion.p 
              className="hero-subtitle"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.6 }}
            >
              Acesse todos os serviços da Universidade Federal do Amapá em um só lugar. 
              Conecte-se com a excelência acadêmica da Amazônia.
            </motion.p>

            <div className="hero-buttons">
              <motion.button 
                className="cta-button glass primary"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 1 }}
                onClick={onServicosClick}
              >
                <span>Explorar Serviços</span>
                <ArrowRight size={20} />
              </motion.button>
              <motion.button 
                className="cta-button glass secondary"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 1.2 }}
                onClick={onMapaClick}
              >
                <span>Mapa de Unidades</span>
                <ArrowRight size={20} />
              </motion.button>
              <motion.button
                className="cta-button glass tertiary"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 1.4 }}
                onClick={handleValidarCredenciais}
              >
                <span>Validar Credenciais</span>
                <ArrowRight size={20} />
              </motion.button>
            </div>
          </motion.div>

          <motion.div 
            className="hero-visual"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.3 }}
          >
                          <div className="hero-card glass-dark">
                <div className="card-header">
                  <div className="logo-container">
                    <img src={logo} alt="Logo UNIFAP" className="logo-icon-logo"/>
                  </div>
                  <h3>Boas vindas à UNIFAP</h3>
                </div>
                <p>
                  Universidade Federal do Amapá <br/> 
                  Conectando conhecimento e inovação na Amazônia
                </p>
                <div className="card-badge">
                  <a href="https://unifap.br" target="_blank" rel="noopener noreferrer"><span>Acesse o site da UNIFAP</span></a> 
                </div>
              </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 